// Module

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgRedux, NgReduxModule } from '@angular-redux3/store';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AppRoutingModule } from './containers/app-routing.module';
// Component
import { AppComponent } from './app.component';
// Misc
import { environment } from '../environments/environment';
import { PlaylistRemoteAppState } from './store';
import { rootReducer, store } from './app.store';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ContainersModule } from './containers/containers.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from './shared.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
  ],
    imports: [
        AppRoutingModule,
        CommonModule,
        BrowserModule,
        TranslateModule.forRoot({
          loader: {
            provide: TranslateLoader,
            useFactory: createTranslateLoader,
            deps: [HttpClient]
          },
          isolate : false
        }),
        SharedModule.forRoot(),
        ContainersModule,
        BrowserAnimationsModule,
        OverlayModule,
        MatSnackBarModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.enableServiceWorker,
            registrationStrategy: 'registerImmediately'
        }),
        HttpClientModule,
        NgReduxModule,
    ],
  bootstrap: [AppComponent],
  exports: [
  ]
})

export class AppModule {
  constructor(ngRedux: NgRedux<PlaylistRemoteAppState>) {
    ngRedux.provideStore(rootReducer, store);
  }
}
